import type { IFormNode, PartialNode } from "@shared/common/node/type";
import { writable, type Writable } from "svelte/store";

type State = {
  formData: Writable<Record<string, unknown>>;
  formElement: Writable<HTMLFormElement | null>;
  formNode: Writable<PartialNode<IFormNode> | null>;
};

const createStore = () => {
  const state: State = {
    formData: writable({}),
    formElement: writable(null),
    formNode: writable(null),
  };
  return {
    state,
    reset: () => {
      state.formData.set({});
      state.formElement.set(null);
      state.formNode.set(null);
    },
  };
};

export default createStore;
